import useDealer from "hooks/useDealer";
import DealerPageTech from "views/Dealers/Tabs/DealerPageTech";

// core components
import PageLayout from "layouts/PageLayout";

// @material-ui/icons
import { Assignment } from "components/MaterialSymbol/MaterialIcons";

export default function DealerPagetechView({ ...otherProps }) {
    const dealer = useDealer();

    return (
        <PageLayout {...otherProps}>
            <DealerPageTech dlid={dealer.id} />
        </PageLayout>
    );
}
